(ns frontend.view.settings2.creation-flow-toggle.view
  (:require [common.localization :as loc]
            [frontend.actions.account :as account-actions]
            [frontend.actions.tenant :as tenant-actions]
            [frontend.logging :as logging]
            [frontend.state.current-session :as session]
            [reagent.core :as r]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.toggle.view :as toggle]
            [ui.editors.labelled-input.view :as labelled-input]
            [ui.util :as uu]))

(defn view
  "Parametric for-me / for-all toggle pair for opportunity-creation flows and
   similar preference-keyed feature switches. Accepts:

   - :preference-key — the keyword used in tenant/account preferences
   - :title-loc-key — section title
   - :for-me-loc-key / :for-all-loc-key — toggle labels
   - :info-loc-key — tooltip text shown over the for-me toggle
   - :info-icon-tooltip — text shown by the info-icon next to the title;
     caller is responsible for localization (so interpolation stays call-side)"
  [{:keys [preference-key
           title-loc-key
           for-me-loc-key
           for-all-loc-key
           info-loc-key
           info-icon-tooltip]}]
  (r/with-let [local-state (r/atom {})]
    (let [for-all? (get @session/tenant-preferences preference-key)
          for-me? (get @session/account-preferences preference-key)
          disabled? (:processing? @local-state)]
      [:div
       {:class (uu/cm "flex flex-col gap-2")}
       [:div
        {:class (uu/cm "text-lg text-bold")}
        [:span
         {:class "flex flex gap-2"}
         (loc/tr title-loc-key)
         (when info-icon-tooltip
           [tooltip/view
            [:i.fal.fa-info-circle]
            info-icon-tooltip])]]
       [:div
        {:class (uu/cm "flex gap-2")}
        [labelled-input/label-elem
         {:label (loc/tr for-me-loc-key)}]
        [(if info-loc-key
           tooltip/view
           :<>)
         [toggle/toggle
          {:checked? (if for-all?
                       true
                       for-me?)
           :disabled? (or disabled?
                          for-all?)
           :on-change (fn [new-value]
                        (swap! local-state assoc :processing? true)
                        (account-actions/*->update-preferences
                         {:account/preference {preference-key new-value}}
                         (fn [_]
                           (js/setTimeout
                            (fn [_]
                              (swap! local-state dissoc :processing?))
                            200)
                           (logging/info "Update successful!"))
                         (fn [err]
                           (swap! local-state dissoc :processing?)
                           (logging/error "Failed to update " err))))}]
         (when info-loc-key
           [:span
            (loc/tr info-loc-key)])]]
       [:div
        {:class (uu/cm "flex gap-2")}
        [labelled-input/label-elem
         {:label (loc/tr for-all-loc-key)}]
        [toggle/toggle
         {:checked? for-all?
          :disabled? disabled?
          :on-change (fn [new-value]
                       (tenant-actions/*->update-preference!
                        preference-key
                        new-value
                        (fn [_]
                          (js/setTimeout
                           (fn [_]
                             (swap! local-state dissoc :processing?))
                           200)
                          (logging/info "Update successful!"))
                        (fn [err]
                          (swap! local-state dissoc :processing?)
                          (logging/error "Failed to update " err))))}]]])))
